import { MediaFile, OwnerUser } from "..";
import { LeadCustomerDetails, PartnerInfo, VehicleUserDetails } from "./lead";

export enum ChangeType {
  Name = "Name",
  PhoneNumber = "PhoneNumber",
  CivilId = "CivilId",
  Email = "Email",
}

export interface Customer {
  createdDate?: string;
  officialEmail?: string;
  officialMobile?: string;
  _id?: string;
  prefix?: string;
  contactType?: string;
  contactCategory?: string;
  contactStatus?: string;
  remarks?: string;
  panNumber?: string;
  gstNumber?: string;
  firstName?: string;
  lastName?: string;
  firstLastName?: string;
  fullName?: string;
  ageRange?: string;
  dob?: string;
  phones?: Phone[];
  directNumber?: Phone[];
  assistantName?: string;
  assistantNumber?: string;
  assistantDesignation?: string;
  seniority?: string;
  department?: string;
  associationStartDate?: string;
  associationEndDate?: string;
  // directionWithCompany?: string;
  accountManager?: string;
  emails?: EmailAddress[];
  addresses?: Address[];
  houseName?: string;
  houseNumber?: string;
  address?: string;
  unitType?: string;
  block?: string;
  street?: string;
  district?: string;
  otherDistrict?: string;
  governorate?: string;
  postalCode?: string;
  country?: string;
  paciNumber?: string;
  addressType?: string;
  isPrimary?: boolean;
  primaryEmail?: string;
  primaryPhone?: string;
  phone?: string;
  bloodGroup?: string;
  nationality?: string;
  isAlghanimEmployee?: boolean;
  profession?: string;
  sensitiveCustomer?: boolean;
  tags?: string[];
  maritalStatus?: string;
  numberOfChildren?: number;
  children?: Childrens[];
  languagesSpeak?: string[];
  preferredLanguage?: string;
  gender?: string;
  socialMediaIds?: SocialMedia[];
  preferredTimes?: PreferredTime[];
  documents?: Document[];
  workDetails?: WorkExperience[];
  avatar?: any;
  middleName?: string;
  shortName?: string;
  secondSurname?: string;
  middleParts?: string;
  pfNumber?: string;
  identifiers?: {
    _id: string;
    nationality: string;
    civilId: string;
    magicNumber?: string;
  };
  name?: string;
  createdAt?: string;
  updatedAt?: string;
  partnerInfo?: PartnerInfo;
  vehicleDetails?: VehicleUserDetails[];
  civilIdDetails?: CivilIdDetails;
  photo?: any;
  civilId?: string;
  knownAs?: string;
  vehicles?: CustomerVehicle[];
  incomeRange?: string;
  last24HoursAssignedLeadsCount?: number;
  last30DaysAssignedLeadsCount?: number;
  last7DaysAssignedLeadsCount?: number;
  todaysAssignedLeadCount?: number;
  arabicFirstName?: string;
  arabicLastName?: string;
  arabicMiddleName?: string;
  showroomIds?: string[];
  crmAgentAssignedLeadsCount?: number;
  allAssignedLeadsCount?: number;
  isBlocked?: boolean;
  blockingReason?: string;
  blockingComment?: string;
  parentCompanyCustomer?: LeadCustomerDetails;
  parentCompanyCustomerId?: string;
  isCompanyCustomer?: boolean;
  divisionId?: string;
  influencerId?: string;
  designationId?: string;
  influencer?: {
    name: string;
    _id: string;
  };
  designation?: {
    name: string;
    _id: string;
  };
  company?: {
    name: string;
    _id: string;
  };
  division?: {
    name: string;
    _id: string;
  };
  companyId?: string;
  state?: string;
  city?: string;
  dinNumber?: string;
  linkedinProfile?: string;
  profileImage?: string;
  maskContact?: boolean;
  facebookProfile?: string;
  customerContactType?: string;
  isDirectorOfCompany?: string;
  isVerified?: string;
}

export interface WorkExperience {
  _id?: string;
  jobTitle?: string;
  employmentType?: string;
  companyName?: string;
  businessType?: string;
  location?: string;
  isCurrentEmployer?: string;
  startDate?: Date;
  endDate?: Date;
  companyPosition?: string;
}

export interface Phone {
  phone: string;
  phoneType: string;
  isPrimary: boolean;
  whatsappNumber?: true;
  isVerified?: true;
  dialCode?: string;
}

export interface EmailAddress {
  email: string;
  emailType: string;
  isPrimary: boolean;
  isVerified?: boolean;
}

export interface Childrens {
  name: string;
  age?: number;
  gender: string;
}

export interface Address {
  _id?: string;
  houseName?: string;
  houseNumber?: string;
  address?: string;
  unitType?: string;
  block?: string;
  street?: string;
  district?: string;
  governorate?: string;
  postalCode?: string;
  country?: string;
  paciNumber?: string;
  addressType?: string;
  isPrimary: boolean;
  floor?: string;
  line1?: string;
  line2?: string;
  city?: string;
  cityID?: string;
  cityObjectId?: string;
  unit?: string;
  zip?: string;
  state?: string;
  region?: string;
  building?: string;
  area?: string;
  isOtherDistrict?: boolean;
  remarks?: string;
  contactStatus?: string;
}

export interface SocialMedia {
  name: string;
  socialId: string;
}

export interface PreferredTime {
  weekday: string;
  startTime: string;
  endTime: string;
}

export interface Document {
  _id?: string;
  documentType?: string;
  issuedBy?: string;
  issuedCountry?: string;
  nationality?: string;
  imageFront?: any;
  imageBack?: any;
  issuedDate: Date;
  expiryDate?: Date;
  licenseType?: string;
  paciNumber?: string;
  cardSerialNumber?: string;
  chipSerialNumber?: string;
  document?: MediaFile;
}

export interface CivilIdDetails {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  arabicFirstName?: string;
  arabicLastName?: string;
  arabicMiddleName?: string;
  gender?: string;
  dob?: string;
  bloodGroup?: string;
  nationality?: string;
  passportNumber?: string;
  issueDate?: string;
  expiryDate?: string;
  residence?: string;
  sponsor?: string;
  email?: string;
  phone?: string;
  alternatePhone?: string;
  address?: Address;
  civilId?: string;
  avatar?: string;
  civilIdRawData?: any;
  prefix?: string;
}

export interface ISalesPersonFilter {
  cityId?: string;
  cityIds?: (string | undefined)[] | undefined;
  query?: string;
  showroomId?: string;
  companyId?: string;
  modelVariant?: {
    modelCode: string;
    variantCode: string;
  };
  modelVariants?: [
    {
      modelCode: string;
      variantCode: string;
    }
  ];
  hideBlocked?: boolean;
  accountType?: string
}

export enum Relationship {
  Father = "Father",
  Mother = "Mother",
  Brother = "Brother",
  Sister = "Sister",
  Husband = "Husband",
  Daughter = "Daughter",
  Son = "Son",
  Wife = "Wife",
  Driver = "Driver",
}

export interface CustomerVehicle {
  magicNumber: number;
  registrationNumber?: string;
  vehicleNumber?: string;
  modelCode?: string;
  variantCode?: string;
  fueltype?: string;
  newUsed?: string;
  registerDate?: Date;
  vsbNumber?: string;
  deliveryDate?: Date;
  displayName?: string;
  saleDate?: Date;
  salesMan?: string;
  aftersalesExecutive?: string;
  vinNumber?: string;
  vehicleType?: string;
  showroom?: string;
  warrantyExpiryDate?: Date;
  lastServiceDate?: Date;
  nextServiceDate?: Date;
  salesBranch?: string;
  exteriorColor?: string;
  interiorColor?: string;
  saleType?: string;
  modelYear?: string;
  invoiceDate?: Date;
  invoiceNumber?: string;
  vehPurchaseDate?: Date;
  salePrice?: string;
  trasnsmission?: string;
  mileage?: string;
  description?: string;
  chassisNumber?: string;
  colourWheelbase?: string;
  trimcabType?: string;
  modelVariant?: string;
}

export interface CustomerUpdateLog {
  _id?: string;
  oldValue: string;
  newValue: string;
  createdAt?: Date;
  createdBy?: OwnerUser;
  updatedAt?: Date;
  updatedBy?: OwnerUser;
  meta?: any;
  customerId?: string;
  magicNumber?: string;
  civilId?: string;
  phones?: string;
  changeType?: string;
}
export const isVerified = [
  { name: "Verified", value: "verified" },
  { name: "Un Verified", value: "unverified" },
];

export const customerContactType = [
  { name: "Private", value: "private" },
  { name: "Public", value: "public" },
];

export const addressType = [
  { name: "Work", value: "work" },
  { name: "Home", value: "home" },
];

export const contactStatus = [
  { name: "Active", value: "active" },
  { name: "Inactive", value: "inactive" },
];

export const isDirectorOfCompany = [
  { name: "Yes", value: "yes" },
  { name: "No", value: "no" },
];

export const AgeLimit = [
  { name: "17 - 20", from: 26, to: 20 },
  { name: "20 - 25", from: 20, to: 25 },
  { name: "25 - 30", from: 25, to: 30 },
  { name: "30 - 35", from: 30, to: 35 },
  { name: "35 - 40", from: 35, to: 40 },
  { name: "40 - 45", from: 40, to: 45 },
  { name: "45 - 50", from: 45, to: 50 },
  { name: "50 - 55", from: 50, to: 55 },
  { name: "55 - 60", from: 55, to: 60 },
  { name: "60 - 65", from: 60, to: 65 },
  { name: "65 - 70", from: 65, to: 70 },
  { name: "70 - 75", from: 70, to: 75 },
  { name: "75 - 80", from: 75, to: 80 },
  { name: "80 and above", from: 80, to: 120 },
];

export const TypeOfBusiness = [
  {
    name: "Cement company",
  },
  {
    name: "Fishing company",
  },
  {
    name: "Furniture Co.",
  },
  {
    name: "Elect.Appliance",
  },
  {
    name: "Advertising Co.",
  },
  {
    name: "Investment Co.",
  },
  {
    name: "Consultancy Firms",
  },
  {
    name: "Tyres Co Dealers",
  },
  {
    name: "Kuwait Muncipality",
  },
  {
    name: "Banks",
  },
  {
    name: "Taxi Co.",
  },
  {
    name: "Insurance Co.",
  },
  {
    name: "Translation Office",
  },
  {
    name: "Cleaning Agency",
  },
  {
    name: "Airconditioning",
  },
  {
    name: "Photography Studio",
  },
  {
    name: "Army",
  },
  {
    name: "Co op Societies",
  },
  {
    name: "Barber Shop",
  },
  {
    name: "Service Co.",
  },
  {
    name: "Ameeri Diwan",
  },
  {
    name: "Personnel A/c Diwan",
  },
  {
    name: "Embassies",
  },
  {
    name: "Air Travel Agencies",
  },
  {
    name: "Car Agents",
  },
  {
    name: "Heavy Equipment Agt.",
  },
  {
    name: "Freight Agents",
  },
  {
    name: "Movies &amp; Theatres",
  },
  {
    name: "Police",
  },
  {
    name: "Foreign Exchange Est",
  },
  {
    name: "Drug Stores",
  },
  {
    name: "Newspaper House",
  },
  {
    name: "Maintenance Co.",
  },
  {
    name: "Industrial Co.",
  },
  {
    name: "Real Estate Co.",
  },
  {
    name: "Hotels",
  },
  {
    name: "Spare Parts &amp; Acc.",
  },
  {
    name: "Garages",
  },
  {
    name: "Accountance Firms",
  },
  {
    name: "Shipping Co.",
  },
  {
    name: "Private Hospitals",
  },
  {
    name: "Press &amp;Stationary Co",
  },
  {
    name: "Jewellery Shops",
  },
  {
    name: "Mills",
  },
  {
    name: "Restaurant",
  },
  {
    name: "Food Stuff Dealers",
  },
  {
    name: "Contracting Co.",
  },
  {
    name: "Kuwait Custom &amp; Port",
  },
  {
    name: "Libraries",
  },
  {
    name: "Fire Brigage Dept",
  },
  {
    name: "Bakery",
  },
  {
    name: "Private Schools",
  },
  {
    name: "Lubricants &amp; Service",
  },
  {
    name: "Clothing Co/Showroom",
  },
  {
    name: "Lawyer Office",
  },
  {
    name: "Public Institutions",
  },
  {
    name: "Transportation Co.",
  },
  {
    name: "PrivateOil Companies",
  },
  {
    name: "Kuwait Oil Co.",
  },
  {
    name: "KNPC",
  },
  {
    name: "KOAC",
  },
  {
    name: "WOC",
  },
  {
    name: "Getty Oil Co.",
  },
  {
    name: "Housing",
  },
  {
    name: "Information Guidance",
  },
  {
    name: "Public Works",
  },
  {
    name: "Awqaf &amp; Islamic Aff.",
  },
  {
    name: "Commerce &amp; Industry",
  },
  {
    name: "Planning",
  },
  {
    name: "Education",
  },
  {
    name: "Foreign Affairs",
  },
  {
    name: "Interior",
  },
  {
    name: "Defence",
  },
  {
    name: "Social Affairs &amp; Lab",
  },
  {
    name: "Public Health",
  },
  {
    name: "Justice",
  },
  {
    name: "Electricity &amp; Water",
  },
  {
    name: "Finance",
  },
  {
    name: "Communication",
  },
  {
    name: "MINISTRY OF Oil",
  },
  {
    name: "Others",
  },
  {
    name: "NATIONAL GUARDS",
  },
];

export const CompanyPosition = [
  {
    name: "Cashier",
  },
  {
    name: "Store keeper",
  },
  {
    name: "Committee secretary",
  },
  {
    name: "Salesman",
  },
  {
    name: "Sailor",
  },
  {
    name: "Proffessor Univ/Coll",
  },
  {
    name: "Student",
  },
  {
    name: "Soldier",
  },
  {
    name: "Guard",
  },
  {
    name: "Blacksmith",
  },
  {
    name: "Market Guard",
  },
  {
    name: "Border Guard",
  },
  {
    name: "National Guard",
  },
  {
    name: "Baker",
  },
  {
    name: "Tailor",
  },
  {
    name: "Major &amp; Higher Ranks",
  },
  {
    name: "House Wife",
  },
  {
    name: "Priest, Mulla",
  },
  {
    name: "Fireman",
  },
  {
    name: "Businessman",
  },
  {
    name: "Sportsman",
  },
  {
    name: "Postman",
  },
  {
    name: "Driver/Heavy Eqpt.",
  },
  {
    name: "Driver",
  },
  {
    name: "Plumber",
  },
  {
    name: "Secretary",
  },
  {
    name: "Policeman",
  },
  {
    name: "Sheikh",
  },
  {
    name: "House/Landowner",
  },
  {
    name: "Painter",
  },
  {
    name: "Journalists/Reporter",
  },
  {
    name: "Pharmacist/Chemist",
  },
  {
    name: "Shop Owner",
  },
  {
    name: "Company Owner",
  },
  {
    name: "Officer",
  },
  {
    name: "Cook",
  },
  {
    name: "Medical Doctor",
  },
  {
    name: "Pilot",
  },
  {
    name: "Typist",
  },
  {
    name: "Labourer",
  },
  {
    name: "Farash/Maid/Mesenger",
  },
  {
    name: "Gardener",
  },
  {
    name: "Technician",
  },
  {
    name: "Jockey",
  },
  {
    name: "Judge",
  },
  {
    name: "Clerk",
  },
  {
    name: "Writer/Poet",
  },
  {
    name: "Electrician",
  },
  {
    name: "Butcher",
  },
  {
    name: "Computer Programmer",
  },
  {
    name: "Translator",
  },
  {
    name: "Retired",
  },
  {
    name: "Accountant",
  },
  {
    name: "District Attorney",
  },
  {
    name: "Lawyer",
  },
  {
    name: "System Analyst",
  },
  {
    name: "Manager",
  },
  {
    name: "Teacher",
  },
  {
    name: "Foreman",
  },
  {
    name: "Legal Advisor",
  },
  {
    name: "Supervisor",
  },
  {
    name: "Photographer",
  },
  {
    name: "Hostess/Steward",
  },
  {
    name: "Inspector",
  },
  {
    name: "Contractor",
  },
  {
    name: "Employee",
  },
  {
    name: "Actor /Singer",
  },
  {
    name: "Nurse",
  },
  {
    name: "Producer",
  },
  {
    name: "P.R Representative",
  },
  {
    name: "Musician",
  },
  {
    name: "Telephone Operator",
  },
  {
    name: "Librarian",
  },
  {
    name: "Engineer",
  },
  {
    name: "Mechanics",
  },
  {
    name: "Publisher",
  },
  {
    name: "Waiter",
  },
  {
    name: "Carpenter",
  },
  {
    name: "Minister",
  },
  {
    name: "Under Secretary",
  },
  {
    name: "C.D.",
  },
  {
    name: "Other",
  },
  {
    name: "SERGEANT",
  },
  {
    name: "CORPORAL",
  },
  {
    name: "CAPTAIN",
  },
  {
    name: "LIEUTENANT COLONEL",
  },
  {
    name: "COLONEL",
  },
  {
    name: "GENERAL",
  },
  {
    name: "Pension Salary",
  },
];

export enum ContactType {
  Customer = "customer",
  Company = "company",
}

export interface ListCompanyContactUsers {
  companyId: string;
}

export interface AddContact {
  customerId: string;
  companyId: string;
}

export type CustomerEditModalType = {
  isEditName?: boolean;
  isEditPhone?: boolean;
  isEditEmail?: boolean;
  isShowAddressForm?: boolean;
  isEditSecondSurname?: boolean;
  isEditMiddleName?: boolean;
  isEditShortName?: boolean;
  isEditMiddleParts?: boolean;
  isEditCivilId?: boolean;
  isEditDob?: boolean;
  isEditInfluencer?: boolean;
  isEditDesignation?: boolean;
  isEditDivision?: boolean;
  isEditDinNumber?: boolean;
  isEditFacebookProfile?: boolean;
  isEditLinkedinProfile?: boolean;
  isEditCategoty?: boolean;
  isEditContactType?: boolean;
  isEditPanNumber?: boolean;
  isEditGstNumber?: boolean;
  isEditAgeLimit?: boolean;
  isEditContactCategory?: boolean;
  isRemarks?: boolean;
};

export type CompanyCustomerEditModalType = {
  isEditName?: boolean;
  isEditPhone?: boolean;
  isEditEmail?: boolean;
  isShowAddressForm?: boolean;
  isEditSecondSurname?: boolean;
  isEditMiddleName?: boolean;
  isEditShortName?: boolean;
  isEditMiddleParts?: boolean;
  isEditCivilId?: boolean;
  isEditDob?: boolean;
  isEditInfluencer?: boolean;
  isEditDesignation?: boolean;
  isEditDivision?: boolean;
  isEditNationality?: boolean;
  isEditGender?: boolean;
  isEditAssistantDetails?: boolean;
  isEditContactCategory?: boolean;
  isEditAgeLimit?: boolean;
  isRemarks?: boolean;
  id?: string;
};
